import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useContext, useState } from "react";
import { useGetEstimateActionHistory } from "../api/get-action-history";
import { EstimateContext } from "../context/EstimateContext";
import { LoadPopupPanel } from "../../../../components";
import ActionHistoryGrid from "../../../common/action-history-grid/components/ActionHistoryGrid";

export default function ActionHistoryButton() {
	const [isPopupVisible, setPopupVisibility] = useState(false);

	const { order } = useContext(EstimateContext);

	const actionHistory = useGetEstimateActionHistory(order.details.quoteID, isPopupVisible);

	return (
		<>
			<Button
				text="Action History"
				icon="Inscyth-Action-History"
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			<Popup
				title="Action History"
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: () => setPopupVisibility(false)
					}}
					widget="dxButton"
					location="after"
				/>

				<ActionHistoryGrid records={actionHistory.data} />

				<LoadPopupPanel visible={actionHistory.isLoading}></LoadPopupPanel>
			</Popup>
		</>
	)
}
